
import { GameCard } from "monkeybattle-shared";
import { computed, defineComponent, PropType, ref } from "vue";

export default defineComponent({
  name: "Card",
  props: {
    card: {
      type: Object as PropType<GameCard>,
      required: false,
    },
    onBoard: {
      type: Boolean,
      required: false,
    },
    debug: {
      type: Boolean,
      required: false,
    },
  },

  setup(props) {
    const imageLoading = ref(true);
    const showModifiers = computed(() => {
      if (!props.card || !props.card.modifiers) return false;
      else {
        let show = false;
        for (const key in props.card.modifiers) {
          if (props.card.modifiers[key]) show = true;
        }
        return show;
      }
    });

    const getSanitizedFilename = (s: string) =>
      s.replaceAll(/[^A-Za-z0-9]+/g, "");

    return { showModifiers, getSanitizedFilename, imageLoading };
  },
});
